import React                                   from 'react';
import classnames                              from 'classnames';
import { materialThickness as defaultOptions } from 'pu-data/SelectOptions';
import { materialThickness as tooltip }        from 'pu-data/Tooltips';
import TextComponentGroup                      from './TextComponentGroup';

const MaterialThicknessFlex = (props) => {
  const name = 'material_thickness_flex';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <TextComponentGroup
      label={props.label}
      required={props.required}
      name={name}
      inputId={props.inputId}
      value={props.parameters[name]}
      onChange={onChange}
      tooltip={tooltip}
      groupName={props.groupName}
      className={classnames('material-thickness', props.className)} />
  );
};

MaterialThicknessFlex.defaultProps = {
  options : defaultOptions,
  label   : 'Finish<br class="d-none d-lg-block" /> Thickness',
  required: true,
};

export default MaterialThicknessFlex;
